import {
  INITIAL_PREVIEW_WITH_DATA_CONTEXT_STATE,
  PreviewWithDataContext,
  PreviewWithDataContextState,
} from 'modules/templateEditor/context/PreviewWithDataContext';

/**
 * The experiment editor currently doesn't allows import of data feed
 * So, just using the default values for the context attributes used
 * in the preview component section
 */
export const PreviewWithDataContextProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const value: PreviewWithDataContextState = {
    ...INITIAL_PREVIEW_WITH_DATA_CONTEXT_STATE,
    canRefreshPreview: true,
    isDataFeedDataEmpty: true,
    isUserDataEmpty: true,
  };
  return (
    <PreviewWithDataContext.Provider value={value}>{children}</PreviewWithDataContext.Provider>
  );
};
